import { TreeGraph } from "../CoreApp/TreeGraph";

export function GetSmartBreakList(topObj, pageDensity, smartStart, breakList, scMgr) {
  // Assume legal page size which is an aspect ratio of 1.6 (we will adjust this over the course)
  // Pager is 14" X 8.5
  // Assume boxes are 1.75" (wide) by 2/3" (tall). Also need to account for spacing around boxes.

  // topObj is the root database object - QObjDBObject
  //  * GetParent (null if no parent - top of chart)
  //  * GetNumChildren
  //  * GetChildList(true) - get list of children for a given node

  // smartStart (integer) is the number of levels on the first page (1, 2,3 or 4)
  // breakList (Array) is an every array that you populate with where to insert the breaks - push QSCNode into this structure

  // scMgr is the QSubChartMgr reference
  // You only need to get the SCNode when pushing into the breakList
  // var targetNode = this.FindSCNode(DBobj,1); - second parameter is the subchart ID
  // When we start all subcharts are removed so there is only '1' subchart and it has an id of 1

  // pageDensity =  enumSCDensity = { standard : 0, dense : 1};

  var numChildren = topObj.GetNumChildren();

  if (numChildren === 0) {
    return;
  }

  var startBreakList = [];
  startBreakList.push(topObj);

  var remainingLevels = smartStart - 1;
  while (remainingLevels-- > 0) {
    var tmpList = startBreakList.splice(0);

    for (var i = 0; i < tmpList.length; i++) {
      var childList = tmpList[i].GetChildList(true);
      for (var j = 0; j < childList.length; j++) {
        var child = childList[j];
        if (child.GetNumChildren() > 0) {
          startBreakList.push(child);
        }
      }
    }
  }

  for (i = 0; i < startBreakList.length; i++) {
    child = startBreakList[i];
    var targetNode = scMgr.FindSCNode(child, 1);
    breakList.push(targetNode);

    var mainGraph = new TreeGraph();
    var optimizedBreaks = mainGraph.InitGraph(child, pageDensity);

    for (j = 1; j < optimizedBreaks.length; j++) {
      if (optimizedBreaks.length > 1) {
        var node = optimizedBreaks[j];
        var breakObj = node.fObj;
        targetNode = scMgr.FindSCNode(breakObj, 1);
        breakList.push(targetNode);
      }
    }
  }
}
